enum Cookies {
  PWA_NEXT_ENABLED = 'pwa-next-enabled',
  USER_IDENTIFIER = 'ha_anonymous_id',
  FEATURES = 'ha-feature-flags',
  ADVERTISER_REVIEWS_ANSWER = 'ha-advertiser-reviews-answer',
  RENT_RADAR_ANSWER = 'ha-rent-radar-answer',
  ADVANCED_PRICING_BANNER_SHOWN = 'advanced-pricing-banner-shown',
  MESSAGES_TRANSLATE_LANGUAGE = 'messages-translate-language',
  MULTI_UNIT_BANNER_SHOWN = 'multi-unit-listing-banner-show',
  STUDENT_RESIDENCE_NOTICE_BANNER_SHOWN = 'student_residence_notice_banner_search',
  USER_COUNTRY = 'ha_user_country',
  CONSISTENCY_TOKEN = 'ha_cnst',
}

enum CookiesTime {
  ONE_DAY = 1,
  SEVEN_DAYS = 7,
  ONE_YEAR = 365,
}

// Undefined is equal to Session
const CookiesExpireTime: Partial<Record<keyof typeof Cookies, CookiesTime>> = {
  USER_IDENTIFIER: CookiesTime.ONE_YEAR,
  USER_COUNTRY: CookiesTime.SEVEN_DAYS,
  FEATURES: undefined,
};

export { Cookies, CookiesExpireTime };
